package one.healthium.domain.user.models

import kotlinx.serialization.Serializable

@Serializable
data class UserSystemModel(
    val playTime: Int?,
    val foodPhotoQuota: FoodPhotoQuotaModel? = null,
    val locale: String? = null,
)
